// The four predicates that read a per-minute offering off the wire, shared by every
// public surface that shows one. Lifted verbatim out of `Reserver.jsx`, which owned them
// alone until the cross-tenant marketplace needed the same four answers: a second copy
// there is how one surface starts calling a paid consultation "Free" while the other
// states its rate (QA-02 — exactly the bug that was live on `MarketplaceLearn.jsx`).
// Pure functions over the payload, no hook, no i18n: `ConsultRateLabel` renders what
// these select.
//
// ONE SHAPE. Every input is a SERVICE row carrying `pricing_mode` and `consult_pricing`
// at its own top level: a chooser row (GET /api/public/booking/services), the `service`
// object of GET /api/availability?service_id=… (the same advertised shape, built by
// `service._service_detail`), or a marketplace practitioner's `services[]` row. Under
// open hours there is no slot object any more, so nothing nests the fields.

// G5 / contract item 1 — the per-minute pricing snapshot. `null` means "not a per-minute
// offering right now": the server sends an explicit `null` for a per-minute service with
// no active rate (`tenant_pricing`) and for every fixed-price one, so the two collapse to
// the same falsy value here on purpose — nothing downstream needs to tell them apart.
export const consultOf = (s) => s?.consult_pricing || null;
export const isPerMinute = (s) => Boolean(consultOf(s));

// A service's OWN mode flag — distinct from `isPerMinute` above, and the only way to
// tell "a fixed-price service" apart from "a per-minute service whose practitioner has
// not set a rate yet" (both read `consultOf(s) === null`). Needed once, to keep an
// unpriced per-minute service off the chooser (contract item 1: "consult: null => the
// SPA hides the service") without also hiding every ordinary fixed-price or free one.
export const isPerMinuteMode = (s) => s?.pricing_mode === "per_minute";
export const isUnbookablePerMinute = (s) => isPerMinuteMode(s) && !isPerMinute(s);
